import React from 'react';
import { Link } from 'react-router-dom';
import { useGetApp } from './GetTheApp';

/** The wordmark, matching the app's: "lr" in Georgia with an amber full stop. */
export function Wordmark() {
  return (
    <Link to="/" className="wordmark">
      lr<span>.</span>
    </Link>
  );
}

export function Nav() {
  const getApp = useGetApp();
  return (
    <nav className="nav">
      <Wordmark />
      <button className="nav-cta" onClick={() => getApp()}>
        Get the app
      </button>
    </nav>
  );
}

/**
 * Book covers are either an uploaded image or an emoji on a colour, exactly as
 * BookCover.tsx renders them in the app.
 */
export function Cover({ series, className = 'cover' }) {
  if (series?.coverImageUrl) {
    return <img className={className} src={series.coverImageUrl} alt="" />;
  }
  return (
    <div className={className} style={{ background: series?.coverColor || '#3E6AE1' }}>
      <span role="img" aria-hidden="true">
        {series?.coverEmoji || '📚'}
      </span>
    </div>
  );
}

export function Footer() {
  return (
    <footer className="footer">
      Long reads · <a href="https://splat.sh/longreads/privacy">Privacy</a>
    </footer>
  );
}
